import React from "react";
import "./index.css";
import {
  FaTwitter,
  FaGithubAlt,
  FaFacebook,
  FaLinkedinIn,
  FaYoutubeSquare,
} from "react-icons/fa";

const profiles = [
  {
    id: "twitter",
    label: "Twitter",
    icon: <FaTwitter />,
    href: "https://twitter.com/webenamhossain",
  },
  {
    id: "github",
    label: "GitHub",
    icon: <FaGithubAlt />,
    href: "https://github.com/Enamhossain",
  },
  {
    id: "facebook",
    label: "Facebook",
    icon: <FaFacebook />,
    href: "https://www.facebook.com/anam.hossein.7",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    icon: <FaLinkedinIn />,
    href: "https://www.linkedin.com/in/webenamhossain",
  },
  {
    id: "youtube",
    label: "YouTube",
    icon: <FaYoutubeSquare />,
    href: "https://www.youtube.com/@webenamhossain",
  },
];

export const Socialicons = () => {
  return (
    <nav className="stick_follow_icon" aria-label="Follow me on social media">
      <p className="follow">Follow me</p>
      <ul>
        {profiles
          .filter((profile) => Boolean(profile.href))
          .map((profile) => (
            <li key={profile.id}>
              <a
                href={profile.href}
                aria-label={profile.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                {profile.icon}
              </a>
            </li>
          ))}
      </ul>
    </nav>
  );
};